import { useState, useCallback} from 'react';
import { PROGRESS_MESSAGES } from '../constants/stringConstants';

const useMigrationProgress = () => {
  const [progress, setProgress] = useState({});

  const startProgress = useCallback((objectId, initialStatus = PROGRESS_MESSAGES.STARTING) => {
    setProgress(prev => ({
      ...prev,
      [objectId]: { status: 'IN_PROGRESS', message: initialStatus, timestamp: Date.now() }
    }));
  }, []);

  const updateProgress = useCallback((objectId, status, message) => {
    setProgress(prev => ({
      ...prev,
      [objectId]: { status, message, timestamp: Date.now() }
    }));
  }, []);

  const clearProgress = useCallback((objectId) => {
    setProgress(prev => {
      const newProgress = { ...prev };
      delete newProgress[objectId];
      return newProgress;
    });
  }, []);

  const clearAllProgress = useCallback(() => setProgress({}), []);


  return {
    progress,
    startProgress,
    updateProgress,
    clearProgress,
    clearAllProgress,
  };
};

export default useMigrationProgress;